import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Empty } from "antd";

const useStyles = makeStyles({
  container: {
    backgroundColor: "white",
    padding: 20,
    borderRadius: 30,
  },
  text: {
    textAlign: "center",
    whiteSpace: "break-spaces",
    fontWeight: 300,
  },
});

const NGIEmpty = ({
  text = "No records found\n" + "Request returned an empty result set. Retry to fetch data.",
  ...props
}) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Empty description="" />
      <div className={classes.text}>{text}</div>
    </div>
  );
};
export default NGIEmpty;
